import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useLocation, matchPath, NavLink } from 'react-router-dom';

import { useMemo, forwardRef } from 'react';

import useSidebar from './useSidebar';

type Props = {
  link: string;
  label: string;
  isMobile: boolean;
};

const Item = ({ link, label, isMobile }: Props) => {
  const location = useLocation();
  const { sidebarClose } = useSidebar();

  // it needs to be exact: false, to routes with nested routes
  const hasMatched = !!matchPath(location.pathname, {
    path: link,
    exact: true,
  });

  const renderLink = useMemo(
    () =>
      forwardRef((itemProps, ref) => (
        <NavLink to={link} ref={ref} {...itemProps} />
      )),
    [link],
  );

  const onClick = () => {
    if (isMobile) {
      sidebarClose();
    }
  };

  return (
    <ListItem
      button
      dense
      component={renderLink}
      onClick={onClick}
      disableGutters
      selected={hasMatched}
    >
      <ListItemText primary={label} />
    </ListItem>
  );
};

export default Item;
